/**
 * Vite entry. Mounts <App /> into #root and pulls in the global
 * stylesheet which imports `@sill/ui/css/reset`, `theme`, and `fonts`.
 * <FontLoader /> is mounted inside <App /> (under the ThemeProvider)
 * rather than here so its lifecycle is tied to the app tree.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import './styles/globals.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Sill admin: #root element missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
